import {
  post, get, put, remove
} from '@api';
import { Store } from 'react-notifications-component';
import {
  COMMON_DATA_DELETE_FAIL,
  COMMON_DATA_DELETE_SUCCESS,
  COMMON_DATA_UPDATE_FAIL,
  COMMON_DATA_UPDATE_SUCCESS
} from '../../constants/notification-settings';

export const FETCH_ATTRIBUTES_SETS_START = 'FETCH_ATTRIBUTES_SETS_START';
export const FETCH_ATTRIBUTES_SETS_SUCCESS = 'FETCH_ATTRIBUTES_SETS_SUCCESS';
export const FETCH_ATTRIBUTES_SETS_FAIL = 'FETCH_ATTRIBUTES_SETS_FAIL';
export const WRITE_ATTRIBUTES_SET_START = 'WRITE_ATTRIBUTES_SET_START';
export const WRITE_ATTRIBUTES_SET_SUCCESS = 'WRITE_ATTRIBUTES_SET_SUCCESS';
export const WRITE_ATTRIBUTES_SET_FAIL = 'WRITE_ATTRIBUTES_SET_FAIL';
export const DELETE_ATTRIBUTES_SET_START = 'DELETE_ATTRIBUTES_SET_START';
export const DELETE_ATTRIBUTES_SET_SUCCESS = 'DELETE_ATTRIBUTES_SET_SUCCESS';
export const DELETE_ATTRIBUTES_SET_FAIL = 'DELETE_ATTRIBUTES_SET_FAIL';
export const CHANGE_ATTRIBUTES_SET_SUCCESS = 'CHANGE_ATTRIBUTES_SET_SUCCESS';
export const UPDATE_ATTRIBUTES_SET_SUCCESS = 'UPDATE_ATTRIBUTES_SET_SUCCESS';
export const UPDATE_ATTRIBUTES_POSITION = 'UPDATE_ATTRIBUTES_POSITION';
export const UPDATE_ATTRIBUTES_SCHEMA_WITH_POSITIONS = 'UPDATE_ATTRIBUTES_SCHEMA_WITH_POSITIONS';

const fetchAttributesSetsStart = () => ({
  type: FETCH_ATTRIBUTES_SETS_START
});

export const fetchAttributesSetsSuccess = (data) => ({
  type: FETCH_ATTRIBUTES_SETS_SUCCESS,
  payload: data
});

const fetchAttributesSetsFail = (err) => ({
  type: FETCH_ATTRIBUTES_SETS_FAIL,
  payload: err
});

const writeAttributesSetStart = () => ({
  type: WRITE_ATTRIBUTES_SET_START
});

export const writeAttributesSetSuccess = (newAttr) => ({
  type: WRITE_ATTRIBUTES_SET_SUCCESS,
  payload: newAttr
});

const writeAttributesSetFail = (err) => ({
  type: WRITE_ATTRIBUTES_SET_FAIL,
  payload: err
});

const deleteAttributesSetStart = () => ({
  type: DELETE_ATTRIBUTES_SET_START
});

export const deleteAttributesSetSuccess = (id) => ({
  type: DELETE_ATTRIBUTES_SET_SUCCESS,
  payload: id
});

const deleteAttributesSetFail = (err) => ({
  type: DELETE_ATTRIBUTES_SET_FAIL,
  payload: err
});

const changeAttributesSetSuccess = (changedSet) => ({
  type: CHANGE_ATTRIBUTES_SET_SUCCESS,
  payload: changedSet,
});

export const updateAttributesSetSuccess = (draggedItem) => ({
  type: UPDATE_ATTRIBUTES_SET_SUCCESS,
  payload: draggedItem
});

export const updateAttributesPosition = (positions) => ({
  type: UPDATE_ATTRIBUTES_POSITION,
  payload: positions
});

export const updateAttributesSchemaWithPositions = (payload) => ({
  type: UPDATE_ATTRIBUTES_SCHEMA_WITH_POSITIONS,
  payload
});

export const fetchAttributesSets = ({ limit, offset }) => async (dispatch) => {
  dispatch(fetchAttributesSetsStart());
  try {
    const result = await get(`/attributes-sets?limit=${limit}&offset=${offset}`);
    const items = Array.isArray(result.data?.items) ? result.data.items : [];
    items.sort((a, b) => a.position - b.position);
    dispatch(fetchAttributesSetsSuccess({ ...result.data, items }));
  } catch (e) {
    dispatch(fetchAttributesSetsFail(e));
  }
};

export const writeAttributesSet = (newSet, translations) => async (dispatch) => {
  dispatch(writeAttributesSetStart());
  try {
    const result = await post('/attributes-sets', newSet);
    dispatch(writeAttributesSetSuccess(result.data));
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    return true;
  } catch (e) {
    dispatch(writeAttributesSetFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return false;
  }
};

export const deleteAttributesSet = (id, translations, setDeleteProcess) => async (dispatch) => {
  dispatch(deleteAttributesSetStart());
  try {
    const result = await remove(`/attributes-sets/${id}`);
    if (result?.data?.result) {
      dispatch(deleteAttributesSetSuccess(id));
      Store.addNotification(COMMON_DATA_DELETE_SUCCESS(translations));
      setDeleteProcess((prev) => prev.filter((elId) => elId !== id));
    } else {
      Store.addNotification(COMMON_DATA_DELETE_FAIL(translations, result?.data?.message));
      setDeleteProcess((prev) => prev.filter((elId) => elId !== id));
      dispatch(deleteAttributesSetFail());
    }
  } catch (e) {
    dispatch(deleteAttributesSetFail(e));
    Store.addNotification(COMMON_DATA_DELETE_FAIL(translations));
  }
};

/**
 * @deprecated or should be rewritten
 */
/**
 * Копирование значений атрибутов набора между языками (сценарий 2).
 * Возвращает объект `{mode: 'sync', updated}` либо `{mode: 'queued', jobId}`.
 * Не wrapping'уется в dispatch — это прямой вызов эндпоинта, результат
 * используется вызывающим кодом (например, для запуска polling'а).
 */
export const copyAttributesSetValues = async (id, payload) => {
  const result = await post(`/attributes-sets/${id}/copy-values`, payload);
  return result?.data;
};

/**
 * Получение статуса job'а копирования (сценарий 2, queued mode).
 */
export const getCopyAttributesSetValuesStatus = async (jobId) => {
  const result = await get(`/attributes-sets/copy-values/status/${jobId}`);
  return result?.data;
};

/**
 * Получение схемы локализованных ключей (`localize_infos`) для набора атрибутов
 * по его id. Источник правды — backend-константа
 * `LOCALIZE_INFO_KEYS_BY_SET_TYPE` (см. `cms/src/modules/attributes-sets/constants.ts`).
 *
 * Возврат:
 *  - `{ keys: string[] }` — успех (массив ключей consumer-сущностей этого типа набора);
 *  - `{ keys: null }` — сигнал «endpoint недоступен, используй статический fallback
 *    из `LOCALIZE_INFO_FIELDS_BY_SET_TYPE` на фронте».
 */
export const fetchAttrSetLocalizeInfoSchema = async (id) => {
  try {
    const result = await get(`/attributes-sets/${id}/localize-info-schema`);
    return { keys: result?.data?.keys ?? [] };
  } catch (err) {
    console.warn('[localize-info-schema] fallback to static map', err);
    return { keys: null };
  }
};

/**
 * Журналирование операции копирования внутри одной сущности (сценарий 1).
 * Вызывается фронтом ПОСЛЕ успешного локального копирования
 * attributesSets/localizeInfos — сам endpoint ничего не меняет в БД,
 * но через @Journalable-interceptor событие попадает в модуль Журнал.
 * Fire-and-forget: ошибка журналирования не должна ломать UX.
 */
export const logCopyEntity = async (payload) => {
  try {
    await post('/attributes-sets/log-copy-entity', payload);
  } catch (e) {
    // fire-and-forget — не падаем на журналировании
    console.warn('logCopyEntity failed:', e?.message || e);
  }
};

/**
 * Получение scope хранения атрибутов сущности (index/view/elastic) для модалки
 * EntityIndexScopeModal. Тонкая обёртка над GET-эндпоинтом, результат
 * используется напрямую вызывающим кодом (не через dispatch). Возвращает
 * `null`, если ответ пуст.
 */
export const fetchEntityIndexScope = async ({ table, id, langCode }) => {
  const params = new URLSearchParams({ table, id: String(id) });
  if (langCode) {
    params.set('langCode', langCode);
  }
  const result = await get(`/index-attributes/entity-scope?${params.toString()}`);
  return result?.data ?? null;
};

/**
 * Получение детализации использования набора атрибутов (где используется).
 * Тонкая обёртка над GET-эндпоинтом; результат используется напрямую в
 * модалке AttributeSetUsageModal (не через dispatch). Возвращает null при
 * пустом ответе.
 */
export const fetchAttributeSetUsage = async (id, langCode) => {
  const params = new URLSearchParams();
  if (langCode) {
    params.set('langCode', langCode);
  }
  const qs = params.toString();
  const result = await get(`/attributes-sets/${id}/usage${qs ? `?${qs}` : ''}`);
  return result?.data ?? null;
};

export const updatePositionAttributes = (attributes, translations) => async (dispatch) => {
  dispatch(writeAttributesSetStart());
  try {
    const positions = await put('/attributes-sets/position', attributes);
    dispatch(updateAttributesPosition(positions.data.payload));
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    return true;
  } catch (e) {
    dispatch(writeAttributesSetFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return false;
  }
};

export const changeAttributesSet = (changedSet, translations, deleted, deletedId, callback) => async (dispatch) => {
  dispatch(writeAttributesSetStart());
  try {
    const { type, ...cleanedSet } = changedSet;
    await put(`/attributes-sets/${changedSet.id}`, {
      ...cleanedSet, deleted, deletedId
    });
    dispatch(changeAttributesSetSuccess(changedSet));
    // @deprecated
    // dispatch(getSettings());
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    if (callback) {
      callback();
    }
    return true;
  } catch (e) {
    dispatch(writeAttributesSetFail(e));
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return false;
  }
};

export const changeAttributesSetSchema = (id, schema) => async (dispatch) => {
  try {
    await put(`/attributes-sets/${id}/schema`, schema);
    dispatch(updateAttributesSchemaWithPositions({ id: +id, schema }));
    return true;
  } catch (e) {
    console.error('changeAttributesSetSchema error:', e);
    return false;
  }
};

export const changeVisible = (attributes) => async (dispatch) => {
  try {
    const result = await put(`/attributes-sets/${attributes.id}/change-visibility`, {});
    if (result?.data === true) {
      dispatch(changeAttributesSetSuccess({ ...attributes, isVisible: !attributes.isVisible }));
    }
    return !!result?.data;
  } catch (e) {
    return false;
  }
};
